import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { VISIBILITY_FILTERS } from './constants';
import { FilterItems } from './FilterItems';
import { AccordionButton } from './AccordionButton';
import { VisibilityFiltersProps } from './container';
import styles from './VisibilityFilter.module.css';

export const VisibilityFilter = ({
  visibilityFilters,
  addVisibilityFilter,
  deleteVisibilityFilter,
  isOpen,
  setIsOpen,
}: VisibilityFiltersProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <section
      className={classNames('base-margin-left base-margin-right', styles.root)}
    >
      <div className="col-12">
        <ul className="accordion">
          <li className={classNames({ active: isOpen })}>
            <AccordionButton
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              filtersCount={visibilityFilters.length}
            />
            <div
              className={classNames(
                'accordion__content',
                styles.accordionContent,
                {
                  [styles.accordionContentOpen]: isOpen,
                },
              )}
            >
              <div className={styles.filterBox}>
                <div className={styles.filterColumns}>
                  <span className={styles.filterTitle}>
                    {t('templateManager.filters.visibility.title')}
                  </span>
                  <FilterItems
                    availableFilters={VISIBILITY_FILTERS}
                    selectedFilters={visibilityFilters}
                    addFilter={addVisibilityFilter}
                    deleteFilter={deleteVisibilityFilter}
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};
